











import { Component, Prop, Vue } from 'vue-property-decorator';
// import { Tree } from 'element-ui';
@Component({
  name: 'lb-tree'
  // components: {
  //   'el-tree': Tree
  // }
})
export default class extends Vue {
  @Prop() private value!: any[];
  @Prop() private data!: any[];
  @Prop({
    default: () => {
      return {
        children: 'children',
        label: 'label',
        disabled: 'disabled',
      };
    },
  }) private props!: object;
}
